import { Box, Button } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import styles from "../../../styles/components/messageContentModal.module.scss";
import assest from "../../../json/assest";
import ModalWrapper from "../../../ui/ModalWrapper/ModalWrapper";
import { useMutation } from "react-query";
import { createNote } from "../../../api/functions/note.api";
import { getCurrentUTCDateTime } from "../../../lib/functions/utils.lib";

const VideoRejectionModal = ({ open, onClose, handleUpdate, data }) => {
  // const handleCloseFilterModal = useCallback(() => {
  //   setOpen(false);
  // }, []);

  const [note, setNote] = useState("");
  // console.warn("note", note);

  const [utcDateTime, setUtcDateTime] = useState(getCurrentUTCDateTime());

  const { mutate } = useMutation(createNote, {
    onSuccess: (data) => {
      // console.warn("data", data);
    },
    onError: (error) => {
      // console.warn("error", error);
    },
  });
  // console.warn("data", data);

  const handleConfirmRejection = () => {
    if (note) {
      mutate({ note, note_key: "admin_rejection_reason", video_id: data.id });
    }
    setNote("");
    onClose();
    handleUpdate(2);
  };

  useEffect(() => {
    const timerId = setInterval(() => {
      setUtcDateTime(getCurrentUTCDateTime());
    }, 5000);

    return () => clearInterval(timerId);
  }, []);
  return (
    <ModalWrapper
      open={open}
      onClose={onClose}
      handleClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      className="rejectedModal"
    >
      <Box className={styles.messageModal}>
        <Box className={styles.messageModalHeader}>
          <h4>Video Rejection</h4>
          <p>
            <span>Date:</span> {utcDateTime}
          </p>
        </Box>

        <Box className={styles.messageModalBody}>
          <Box className={styles.messageInput}>
            <label>
              Kindly inform the partner of the reasoning behind the rejection of
              this video.
            </label>
            <textarea onChange={(e) => setNote(e.target.value)}>
              {note}
            </textarea>
          </Box>
        </Box>

        <Box className={styles.messageModalFooter}>
          <Button onClick={onClose}>Cancel</Button>
          <Button onClick={handleConfirmRejection} className={styles.active}>
            Confirm Rejection
          </Button>
        </Box>
      </Box>
    </ModalWrapper>
  );
};

export default VideoRejectionModal;
